<template>
	<span class="channel-avatar" :style="rootStyle">
		<span class="channel-avatar__face" :style="faceStyle">
			<img v-if="showImage" :src="image" alt="" class="channel-avatar__image" @error="failedImage = image" />
			<img v-else-if="isSupport" src="../../assets/images/logo-mini.png" alt="" class="channel-avatar__logo" />
			<img v-else-if="visual.face" :src="visual.face" alt="" class="channel-avatar__image" />
			<chat-icon v-else :name="visual.icon" :size="Math.round(size * 0.5)" :style="{ color: visual.accent }" />
		</span>
		<span v-if="badge" class="channel-avatar__badge" :style="badgeStyle">
			<chat-icon :name="visual.icon" :size="Math.round(badgeSize * 0.6)" />
		</span>
	</span>
</template>

<script>
	import { CHAT_TYPE } from '@/services/chat/channels';
	import ChatIcon from './ChatIcon.vue';
	import { chatChannelVisual } from './chatVisuals';

	export default {
		name: 'ChannelAvatar',
		components: { ChatIcon },
		props: {
			typeId: {
				type: Number,
				required: true,
			},
			image: {
				type: String,
				default: '',
			},
			size: {
				type: Number,
				default: 40,
			},
			badge: {
				type: Boolean,
				default: false,
			},
		},
		data: () => ({
			failedImage: null,
		}),
		computed: {
			visual() {
				return chatChannelVisual(this.typeId);
			},
			isSupport() {
				return this.typeId === CHAT_TYPE.SUPPORT;
			},
			showImage() {
				return !!this.image && this.image !== this.failedImage;
			},
			badgeSize() {
				return Math.max(14, Math.round(this.size * 0.42));
			},
			rootStyle() {
				return { width: `${this.size}px`, height: `${this.size}px` };
			},
			faceStyle() {
				return { backgroundColor: this.showImage || this.isSupport ? 'var(--white)' : this.visual.tint };
			},
			badgeStyle() {
				return {
					width: `${this.badgeSize}px`,
					height: `${this.badgeSize}px`,
					backgroundColor: this.visual.accent,
				};
			},
		},
	};
</script>

<style scoped>
	.channel-avatar {
		position: relative;
		display: inline-block;
		flex-shrink: 0;
	}

	.channel-avatar__face {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		overflow: hidden;
		border: 1px solid #e2e8f0;
		border-radius: 9999px;
	}

	.channel-avatar__image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.channel-avatar__logo {
		width: 62%;
		height: 62%;
		object-fit: contain;
	}

	.channel-avatar__badge {
		position: absolute;
		right: -3px;
		bottom: -3px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--white);
		border: 2px solid var(--white);
		border-radius: 9999px;
	}
</style>
